import Header from './Header';
import Footer from './Footer';
import aluminum_can from '../assets/aluminum-can.png';
import plastic_water_bottle from '../assets/plastic_water_bottle.png';
import glass_bottle from '../assets/glass_bottle.png';
import water_soda_bottles from '../assets/water_soda_bottles.png';
import Beer_malt from '../assets/Beer_malt.png';
import milk from '../assets/milk.png';
import juice_box from '../assets/JuiceBox.png';
import tea from '../assets/tea.png';
import plastic_large from '../assets/waterbottles.png';
import wine from '../assets/wine-liquor.png';


const RecycleItems = () => {
   return (
      <div className="bg-gray-50">
         <Header />
         <div style={{ maxWidth: '1300px' }} className="mx-auto p-4 sm:p-6 lg:p-10">
            <h2 className="text-3xl font-bold text-center mb-10">
               NYC Bottle Bill <span className="text-[#9cc026]">Beverage</span> Types
            </h2>


            {/* Top Section - Text Based */}
            <div className="grid md:grid-cols-2 gap-6 mb-10">
               {/* Acceptable */}
               <div className="bg-white shadow-md rounded-lg p-6 border-l-4 border-green-500">
                  <h3 className="text-lg font-semibold text-blue-800 mb-4">
                     Acceptable Beverage Types (Refundable)
                  </h3>
                  <ul className="list-disc list-inside text-gray-700 space-y-2">
                     <li>Carbonated soft drinks (soda)</li>
                     <li>Carbonated water (seltzer)</li>
                     <li>Water (non-carbonated and carbonated), 1 gallon or less</li>
                     <li>Beer and other malt beverages</li>
                     <li>Wine coolers</li>
                     <li>Sports drinks</li>
                     <li>Juices (less than 100% fruit juice, under 1 gallon)</li>
                     <li>Energy drinks</li>
                  </ul>
               </div>

               {/* Unacceptable */}
               <div className="bg-white shadow-md rounded-lg p-6 border-l-4 border-red-500">
                  <h3 className="text-lg font-semibold text-blue-800 mb-4">
                     Unacceptable Beverage Types (Non-Refundable)
                  </h3>
                  <ul className="list-disc list-inside text-gray-700 space-y-2">
                     <li>Milk and dairy products</li>
                     <li>Hard liquor and spirits</li>
                     <li>Wine</li>
                     <li>Infant formula</li>
                     <li>100% fruit or vegetable juices in containers larger than 1 gallon</li>
                     <li>Non-carbonated tea</li>
                     <li>Medical or nutritional supplements</li>
                     <li>Soup and broth containers</li>
                  </ul>
               </div>
            </div>

            {/* Bottom Section - Icons */}
            <div className="grid md:grid-cols-2 gap-6">
               {/* Acceptable Icons */}
               <div className="bg-white shadow-md rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-green-700 mb-4 text-center">
                     Acceptable Beverage Types
                  </h3>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-center">
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={aluminum_can} alt="Aluminum Can" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Aluminum Cans</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={plastic_water_bottle} alt="Plastic Bottle" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Plastic Bottles (under 1 gallon)</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={glass_bottle} alt="Glass Bottles" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Glass Bottles</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={water_soda_bottles} alt="Water & Soda" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Water & Soda Bottles</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={Beer_malt} alt="Beer" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Beer & Malt Beverages</p>
                     </div>
                  </div>
               </div>

               {/* Unacceptable Icons */}
               <div className="bg-white shadow-md rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-red-600 mb-4 text-center">
                     Unacceptable Beverage Types
                  </h3>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-center">
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={milk} alt="Milk" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Milk Containers</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={juice_box} alt="Juice Box" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Juice Boxes & Pouches</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={tea} alt="Tea" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Non-Carbonated Tea</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={plastic_large} alt="Plastic Large" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Plastic Bottles (over 1 gallon)</p>
                     </div>
                     <div className="bg-gray-200 p-3 rounded-lg">
                        <img src={wine} alt="Wine" className="w-14 h-14 mx-auto" />
                        <p className="mt-2 text-sm">Wine & Liquor Bottles</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <Footer />
      </div>
   );
};

export default RecycleItems;
